import { render, staticRenderFns } from "./receiveQrCode.vue?vue&type=template&id=4ea349ba&scoped=true"
import script from "./receiveQrCode.vue?vue&type=script&lang=js"
export * from "./receiveQrCode.vue?vue&type=script&lang=js"
import style0 from "./receiveQrCode.vue?vue&type=style&index=0&id=4ea349ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea349ba",
  null
  
)

export default component.exports